import p from './role-manage-log.vue';

export default p;
